import React from "react";
import Icon from "@jll/icon";

const RecordIcon = ({ entityCategory, entitySubctegory , t}) => {
  let className = "fas fa-users";
  if (entityCategory === "Natural Person") {
    className = "far fa-user";
  } else if (entityCategory === "Legal Person") {
    className = "far fa-university";
  }
  return <Icon className={className} title={t(`labels.filter.${entityCategory}`)} />;
};

export default RecordIcon;
